<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>UNIT<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="units" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="unitColumns" [selectionField]="'Unit_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addUnit($event)" (editEntity)="editUnit($event)"
            (refreshEntities)="refreshUnits($event)" (deleteEntity)="deleteUnit($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearUnit()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Unit Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                    [fieldName]="'UnitName'" [(ngModel)]="entity.UnitName" 
                    ngDefaultControl>
                </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                    [fieldName]="'UnitPrefix'" [(ngModel)]="entity.UnitPrefix"
                    ngDefaultControl></textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Unit Head'"   [formData]="entity" [data]="employees" [mandatory]="false"
                    [filterable]="true" (filterChanged)="getAllEmployees($event)" [class] = "'form-control'"
                    [(ngModel)]="entity.Emp_Ref_Id" [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'"
                    [fieldName]="'Emp_Ref_Id'" [selectedItem]="selectedEmployee" ngDefaultControl>
                </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Sub Department'" [formData]="entity" [data]="subdepartments" [class] = "'form-control'"
                            [mandatory]="false" [filterable]="true" (filterChanged)="getAllSubDepartments($event)"
                            [(ngModel)]="entity.SubDepartment_Id" [textField]="'SubDepartmentName'"
                            [valueField]="'SubDepartment_Id'" [fieldName]="'SubDepartment_Id'"
                            [selectedItem]="selectedSubDepartment" (selectionChanged)="SubDepartmentchanged($event)" ngDefaultControl>
                        </dropdown>
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Company'" [formData]="entity" [data]="company" [mandatory]="false"
                    [filterable]="true" (filterChanged)="getAllCompany($event)" [(ngModel)]="entity.Company_Id"
                    [textField]="'CompanyName'" [valueField]="'Company_Id'" [fieldName]="'Company_Id'" [class] = "'form-control'"
                    [selectedItem]="selectedCompany" ngDefaultControl>
                </dropdown>
                </div> -->
            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Division'" [formData]="entity" [data]="divisions" [mandatory]="false"
                            [filterable]="true" (filterChanged)="getAllDivisions($event)" [class] = "'form-control'"
                            [(ngModel)]="entity.Division_Id" [textField]="'DivisionName'" [valueField]="'Division_Id'"
                            [fieldName]="'Division_Id'" [selectedItem]="selectedDivision" ngDefaultControl>
                        </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Location'" [formData]="entity" [data]="locations" [mandatory]="false"
                    [filterable]="true" (filterChanged)="getAllLocations($event)" [class] = "'form-control'"
                    [(ngModel)]="entity.Location_Id" [textField]="'LocationName'" [valueField]="'Location_Id'"
                    [fieldName]="'Location_Id'" [selectedItem]="selectedLocation" ngDefaultControl>
                </dropdown>
                </div>
            </div> -->
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Department'" [formData]="entity" [data]="departments" [mandatory]="true"
                            [filterable]="true" (filterChanged)="getAllDepartmentsbySubdepartment($event)" [class] = "'form-control'"
                            [(ngModel)]="entity.Department_Id" [textField]="'DepartmentName'"
                            [valueField]="'Department_Id'" [fieldName]="'Department_Id'"
                            [selectedItem]="selectedDepartment" ngDefaultControl>
                        </dropdown>
                </div>
               
                </div>
            </div> -->
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email Id'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                    [fieldName]="'EmailId'"  [(ngModel)]="entity.EmailId" ngDefaultControl id="drp_Department_Email"></textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [formData]="entity"  [mandatory]="true" id="txt_Department_Phone"
                    [fieldName]="'Phone'"   [(ngModel)]="entity.Phone" (keypress)="numberOnly($event)" [maxlength]="10"
                        ngDefaultControl></textbox>
                </div>
            </div> -->
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div> 
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Unit Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="UnitName" class="label label-1"> Unit Name : </label> {{details.UnitName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="UnitPrefix" class="label label-1">Code : </label> {{details.UnitPrefix}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="EmployeeName" class="label label-1">Unit Head : </label> {{details.EmployeeName}}
          </div>
        </div>
          <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="SubDepartmentName" class="label label-1">Sub Department : </label> {{details.SubDepartmentName}}
          </div>
        </div>
    </div>

    </kendo-dialog>

<kendo-excelexport [data]="units.data" [collapsible]="true" fileName="Unit.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="UnitName" title="Unit" [width]="200">
    </kendo-excelexport-column>     
    <kendo-excelexport-column field="UnitPrefix" title="Code" [width]="200">
    </kendo-excelexport-column>  
    <kendo-excelexport-column field="EmployeeName" title="Unit Head" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DivisionName" title="Division" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="LocationName" title="Name" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DepartmentName" title="Department" [width]="200">
    </kendo-excelexport-column> -->
    <kendo-excelexport-column field="SubDepartmentName" title="Sub Department" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>